import React from "react"

const CORREO = "infotickets@t-ickets.com"
const WHATSAPP = "https://api.whatsapp.com/send?phone=593980009000&text=Solicitud%20de%20reembolso%20por%20evento%20cancelado"

const ModalReembolsos = () => (
  <div className="modal fade" id="reembolsosModal" role="dialog" aria-labelledby="reembolsosModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title text-dark" id="reembolsosModalLabel">POLÍTICA DE REEMBOLSOS</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body text-dark" style={{ maxHeight: 600, overflowY: "auto", fontSize: "0.92em" }}>
          <p>
            Esta política aplica a las compras realizadas en www.t-ickets.com, en las aplicaciones de T-ICKETS y en sus
            puntos de venta autorizados. TICKETSECUADOR S.A. (T-ICKETS), RUC 0993377293001.
          </p>

          <h6 className="font-weight-bold">1. Cuándo aplica el reembolso</h6>
          <p>El reembolso aplica <b>únicamente cuando el evento es cancelado definitivamente</b>. No aplica en los siguientes casos:</p>
          <ul>
            <li>Evento postergado o con cambio de fecha, hora, lugar o artistas: el ticket sigue siendo válido para la nueva fecha.</li>
            <li>Desistimiento o arrepentimiento de la compra, inasistencia o llegada tarde al evento.</li>
            <li>Negativa de ingreso o retiro del evento por incumplir las normas de seguridad o de comportamiento.</li>
            <li>Pérdida, robo o uso indebido del ticket o de su código QR.</li>
          </ul>

          <h6 className="font-weight-bold">2. Valor a reembolsar</h6>
          <p>
            Se reembolsa el valor de la entrada. <b>Los cargos por servicio no son reembolsables</b> en ningún caso.
          </p>

          <h6 className="font-weight-bold">3. Plazo para solicitarlo</h6>
          <p>
            La solicitud debe enviarse dentro de los <b>15 días calendario</b> siguientes al anuncio oficial de la cancelación
            del evento. Las solicitudes fuera de este plazo no serán atendidas.
          </p>

          <h6 className="font-weight-bold">4. Cómo solicitarlo</h6>
          <p>
            Escríbenos al correo <a href={`mailto:${CORREO}?Subject=Solicitud%20de%20reembolso`}>{CORREO}</a> o por{" "}
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer">WhatsApp al +593 98 000 9000</a> con el asunto
            “Solicitud de reembolso” y la siguiente información:
          </p>
          <p className="mb-1"><b>Datos del comprador</b></p>
          <ul>
            <li>Nombre completo y número de cédula (o pasaporte).</li>
            <li>Correo electrónico y número de celular registrados en la cuenta.</li>
            <li>Nombre del evento, número de pedido o compra y cantidad de tickets.</li>
            <li>Comprobante de pago (captura de la transferencia, depósito o pago con tarjeta).</li>
          </ul>
          <p className="mb-1"><b>Datos de la cuenta para la transferencia</b></p>
          <ul>
            <li>Nombre del banco o cooperativa.</li>
            <li>Tipo de cuenta: ahorros o corriente.</li>
            <li>Número de cuenta.</li>
            <li>Nombre completo del titular de la cuenta.</li>
            <li>Cédula o RUC del titular de la cuenta.</li>
            <li>Correo electrónico del titular, para enviar el comprobante de la transferencia.</li>
          </ul>

          <h6 className="font-weight-bold">5. Si la cuenta de reembolso es de otra persona</h6>
          <p>
            Si la cuenta desde la que se realizó el pago y la cuenta donde se hará el reembolso son diferentes, o su titular no
            es el comprador, además se debe enviar:
          </p>
          <ul>
            <li>Carta de autorización firmada por el comprador, indicando el nombre y la cédula de la persona que recibirá el reembolso.</li>
            <li>Copia de la cédula del comprador y del titular de la cuenta.</li>
          </ul>

          <h6 className="font-weight-bold">6. Pagos con tarjeta</h6>
          <p>
            Cuando la pasarela de pago lo permita, el reembolso de compras con tarjeta de crédito o débito podrá hacerse a la
            misma tarjeta; en ese caso los tiempos de acreditación dependen del banco emisor.
          </p>

          <h6 className="font-weight-bold">7. Tiempo de procesamiento</h6>
          <p>
            Una vez recibida la solicitud completa y validada la información, el reembolso puede tardar <b>hasta 30 días</b> en
            acreditarse. Enviaremos la confirmación al correo registrado. Los tickets reembolsados quedan anulados y no
            permitirán el ingreso.
          </p>

          <h6 className="font-weight-bold">8. Verificación</h6>
          <p className="mb-0">
            T-ICKETS podrá solicitar documentos adicionales para verificar la identidad del comprador y la titularidad de la
            cuenta, y podrá rechazar solicitudes incompletas, con datos que no coincidan o con indicios de fraude. Cada
            solicitud se procesa una sola vez. El reembolso se realiza en los términos acordados con el organizador del evento.
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default ModalReembolsos
